import { useEffect } from "react";
import {
  getBorrowedListings,
  getOwnedListings,
  getSwaps,
} from "../../api/listings";
import { useDispatch } from "react-redux";
import useUser from "../user/useUser";
import { useRouter } from "next/router";
import {
  setBorrowedListings,
  setCurrentSwaps,
  setOwnedListings,
} from "../../redux/pages/trainingPlanSlice";
import { useSnackbarContext } from "../../components/global/snackbar/SnackbarProvider";
import { ErrorSnackbar } from "../../components/global/snackbar";

export const useGetDataForSwapOneTimeModal = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { user } = useUser();
  const { setSnackbar } = useSnackbarContext();

  useEffect(() => {
    const getData = async () => {
      try {
        if (user.token) {
          const [swapsFromApi, borrowedListings, ownedListings] =
            await Promise.all([
              getSwaps(user),
              getBorrowedListings(user),
              getOwnedListings(user),
            ]);

          dispatch(setCurrentSwaps(swapsFromApi));
          dispatch(setBorrowedListings(borrowedListings));
          dispatch(setOwnedListings(ownedListings.rows));
        }
      } catch (e) {
        const error = e as Error;
        setSnackbar(<ErrorSnackbar message={error.message} />);
      }
    };

    void getData();
  }, [user, dispatch, router]);
};
